var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Registry } from 'monaco-textmate'; // peer dependency
import { wireTmGrammars } from 'monaco-editor-textmate';
import * as lightPlusTheme from './lightPlus.json';
import * as leanSyntax from './syntaxes/lean.json';
import * as leanMarkdownSyntax from './syntaxes/lean-markdown.json';
import * as codeblockSyntax from './syntaxes/codeblock.json';
import languageConfig from 'lean4/language-configuration.json';
import { loadWASM } from 'onigasm';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import { MonacoServices } from 'monaco-languageclient';
import { StandaloneServices } from 'vscode/services';
import getMessageServiceOverride from 'vscode/service-override/messages';
export function monacoSetup() {
    var _this = this;
    StandaloneServices.initialize(__assign({}, getMessageServiceOverride(document.body)));
    // install Monaco language client services
    MonacoServices.install();
    // map of monaco "language id's" to TextMate scopeNames
    var grammars = new Map();
    grammars.set('lean4', 'source.lean');
    monaco.editor.defineTheme('vs-code-theme-converted', lightPlusTheme);
    // register Monaco languages
    monaco.languages.register({
        id: 'lean4',
        extensions: ['.lean']
    });
    var config = __assign({}, languageConfig);
    config.autoClosingPairs = config.autoClosingPairs.map(function (pair) { return { 'open': pair[0], 'close': pair[1] }; });
    monaco.languages.setLanguageConfiguration('lean4', config);
    var registry = new Registry({
        getGrammarDefinition: function (scopeName) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (scopeName === 'source.lean') {
                    return [2 /*return*/, {
                            format: 'json',
                            content: JSON.stringify(leanSyntax)
                        }];
                }
                else if (scopeName === 'source.lean.markdown') {
                    return [2 /*return*/, {
                            format: 'json',
                            content: JSON.stringify(leanMarkdownSyntax)
                        }];
                }
                else {
                    return [2 /*return*/, {
                            format: 'json',
                            content: JSON.stringify(codeblockSyntax)
                        }];
                }
                return [2 /*return*/];
            });
        }); }
    });
    // Load onigasm
    (function () { return __awaiter(_this, void 0, void 0, function () {
        var err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, loadWASM('./onigasm.wasm')];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _b.sent();
                    // Hot module replacement can cause us to run this code twice and that's ok.
                    if (!((_a = err_1.message) === null || _a === void 0 ? void 0 : _a.startsWith('Onigasm#init has been called'))) {
                        throw err_1;
                    }
                    return [3 /*break*/, 3];
                case 3:
                    wireTmGrammars(monaco, registry, grammars);
                    return [2 /*return*/];
            }
        });
    }); })();
}
